<form [formGroup]="agreementForm">
    <app-form-section formGroupName="details">
        <app-form-row>
            <app-form-group class="report-container">
                <div class="box">
                    <app-general-attributes
                        [detailsForm]="detailsForm"
                        [showPotentialValidationMessages]="true"
                    ></app-general-attributes>
                </div>
                <div class="box">
                    <app-agreement-parts
                        [detailsForm]="detailsForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-parts>
                </div>
                <div class="box" *ngIf="realEstateForm">
                    <app-agreement-real-estate
                        *ngIf="realEstateForm"
                        [realEstateForm]="realEstateForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-real-estate>
                </div>
                <div class="box" *ngIf="rentalForm">
                    <app-agreement-rental
                        *ngIf="rentalForm"
                        [rentalForm]="rentalForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-rental>
                </div>
                <div class="box" *ngIf="inventoryForm">
                    <app-agreement-inventory
                        *ngIf="inventoryForm"
                        [inventoryForm]="inventoryForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-inventory>
                </div>
                <div class="box" *ngIf="paymentForm">
                    <app-agreement-payment
                        *ngIf="paymentForm"
                        [paymentForm]="paymentForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-payment>
                </div>
            </app-form-group>
        </app-form-row>
    </app-form-section>
</form>

<!-- Edit mode disabled template-->
<!-- <ng-template #defaultFooterTemplate>
    <button *appIsAuthorized="editPatientCredentials" class="edit-button secondary" (click)="enterEditMode()">
        <app-icon name="pen" />
        {{ 'SHARED.UI.BUTTONS.EDIT' | translate }}
    </button>
    <button class="primary" (click)="cancel()">
        {{ 'SHARED.UI.BUTTONS.CLOSE' | translate }}
    </button>
</ng-template> -->

<!-- Edit mode enabled template-->
<ng-template #editModeFooterTemplate>
    <button class="secondary" (click)="cancel()">
        {{ 'BUTTONS.CANCEL' | translate }}
    </button>
    <button class="primary green" [class.loading]="submitting" [disabled]="submitting" (click)="save()">
        {{ 'BUTTONS.SAVE' | translate }}
    </button>
</ng-template>
